export class UsuarioInfo {

    grupoId = 0;
	grupoNome = "";
	usuarioId = 0;
	usuarioNome = "";
	admin = false;

}
